module.exports = __webpack_public_path__ + "327da165bc637a79a75698049e17a239.pdf";